import React from 'react';
import { getServicesManager } from '../../services';
import { AIPromptTemplate } from './AIPromptTemplate';
import { summaryExamples } from './promptExamples';

export function CustomSummaries() {
  const services = getServicesManager();

  return (
    <AIPromptTemplate
      title="Summary Prompt"
      description="Define how AI generates call summaries. The transcript and metadata will be automatically appended."
      placeholder="Enter your custom summary prompt here..."
      testResultLabel="Summary"
      examples={summaryExamples}
      getPrompt={() => services.getAISummaryFormat()}
      savePrompt={(prompt) => services.putAISummaryFormat(prompt)}
      testPrompt={(sessionId, prompt) => services.testGenerateAISummary(sessionId, prompt)}
      extractTestResult={(result) => result?.summary || null}
      confirmSaveMessage="This will update the AI summary generation for all team members."
      confirmDeleteMessage="This will remove the custom summary format for all team members."
    />
  );
}
